import React from "react";
import type { ReactNode } from "react";
import { useContext } from "react";
import { useDrag, type DragSourceMonitor } from "react-dnd";
import SelectedHoleContext, { type SelectedHole } from "src/components/providers/SelectedHoleProvider";
import SimpleDomHole from "./SimpleDomHole";
import type { Side } from "../../core/types";
import type { UserClickStoreAction } from "src/reducer";
type Props = {
  seeds: number;
  side: Side;
  dispatch?: (action: UserClickStoreAction) => void;
};

const collect = (monitor: DragSourceMonitor) => {
  return {
    isDragging: !!monitor.isDragging()
  };
};

//const dropCollector = monitor => ({
//  isOver: !!monitor.isOver(),
//  isOverCurrent: !!monitor.isOver({ shallow: true }),
//  canDrop: !!monitor.canDrop()
//});

const StoreHole = (props: Props): ReactNode => {
  const selectedHole = useContext<SelectedHole | undefined>(SelectedHoleContext);
  const [, drag] = useDrag({
    type: "Store",
    item: {
      side: props.side,
      seeds: 1,
      playableDirections: []
    },
    collect,
    canDrag: (monitor) => props.seeds > 0
  });

  return (
    <div css={{ display: "flex", justifyContent: "center" }}>
      <div
        ref={drag as unknown as React.Ref<HTMLDivElement>}
        onClick={() => {
          props.dispatch &&
            props.dispatch({
              type: "USER_CLICK_STORE",
              side: props.side
            });
        }}
        css={(theme) => ({
          backgroundColor:
            selectedHole && selectedHole.storeClicked && selectedHole.side === props.side ? theme.colors.grey7 : "white"
        })}
      >
        <SimpleDomHole holeWidth={200} holeHeight={25} side={props.side} seeds={props.seeds} />
      </div>
    </div>
  );
};
export default StoreHole;
